<template>
  <div>
    <CoolLightBox :items="gallery" :index="index" @close="index = null" />

    <v-row class="ma-n1">
      <template v-for="(img, keyGallery) in gallery">
        <v-col :key="keyGallery" class="pa-1" cols="6" sm="4" md="3" lg="2">
          <img
            class="d-block cursor-pointer item-img"
            :src="img + '?resize=1&w=300'"
            width="100%"
            @click="index = keyGallery"
          />
        </v-col>
      </template>
    </v-row>
  </div>
</template>

<script>
import CoolLightBox from "vue-cool-lightbox";
import "vue-cool-lightbox/dist/vue-cool-lightbox.min.css";

export default {
  props: {
    gallery: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    index: null,
  }),
  components: {
    CoolLightBox,
  },
};
</script>

<style lang="scss" scoped>
.item-img {
  aspect-ratio: 16 / 12;
  object-fit: cover;
  -o-object-fit: cover;
}
</style>
